'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva } from 'class-variance-authority';
import { classNames } from '../utils';
const toggleVariants = cva(
// eslint-disable-next-line quotes
"inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-base-100 hover:text-base-600 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-base-50 data-[state=on]:text-base-700 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-base-300 focus-visible:ring-base-200/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-error-200/20 dark:aria-invalid:ring-error-200/40 aria-invalid:border-error-500 whitespace-nowrap", {
    variants: {
        variant: {
            default: 'bg-transparent',
            outline: 'border border-base-200 bg-transparent shadow-xs hover:bg-base-50 hover:text-base-700',
        },
        size: {
            default: 'h-9 px-2 min-w-9',
            sm: 'h-8 px-1.5 min-w-8',
            lg: 'h-10 px-2.5 min-w-10',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
function Toggle(_a) {
    var { className, variant, size } = _a, props = __rest(_a, ["className", "variant", "size"]);
    return (_jsx(TogglePrimitive.Root, Object.assign({ "data-slot": "toggle", className: classNames(toggleVariants({ variant, size, className })) }, props)));
}
export { Toggle, toggleVariants };
